export const sortDashboardItems = (list: any) => {
    const arrangedDashboardItemList = [];
    arrangedDashboardItemList.push(list.find((item: any) => item.name === 'Send Referral'));
    arrangedDashboardItemList.push(list.find((item: any) => item.name === 'Businesses I Refer'));
    arrangedDashboardItemList.push(list.find((item: any) => item.name === 'My Network'));
    arrangedDashboardItemList.push(list.find((item: any) => item.name === 'Refer ReferUs'));
    arrangedDashboardItemList.push(list.find((item: any) => item.name === 'My Referrals'));
    arrangedDashboardItemList.push(list.find((item: any) => item.name === 'Invite A Referrer'));
    arrangedDashboardItemList.push(list.find((item: any) => item.name === 'ReferUs Network'));
    arrangedDashboardItemList.push(list.find((item: any) => item.name === 'Social Media'));
    arrangedDashboardItemList.push(list.find((item: any) => item.name === 'Account'));
    arrangedDashboardItemList.push(list.find((item: any) => item.name === 'Help'));
    return arrangedDashboardItemList
}

export function formatTitle(str: string) {
  return str
    ?.replace(/\//g, '') // replace all - with space
    ?.replace(/-/g, ' ') // Replace all hyphens with spaces
    ?.split(' ') // Split the string into words
    ?.map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
    ?.join(' '); // Join the words back together with spaces
}

 export function capitalizeFirstLetter(str:string) {
    return str?.charAt(0)?.toUpperCase() + str?.slice(1);
  }

  export function capitalizeAfterComma(str: string) {
    return str?.split(',').map((word, index) => {
      if (index > 0) {
        return word?.trim()?.charAt(0)?.toUpperCase() + word?.slice(1);
      } else {
        return word?.trim();
      }
    }).join(', ');
  }

  export function formatAndCapitalizeString(str: string) {
    return str && str?.replace(/-/g, ' ')?.replace(/\b\w/g, match => match?.toUpperCase());
  }

  export function formatComment(comment: string) {
  if (!comment) return '';
  const words = comment.split(' ');
  if (words.length <= 4) return comment;
  return words.slice(0, 4).join(' ') + '...';
}

  export function extractVideoId(url: string) {
    const urlRegex = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = url?.match(urlRegex);
    return (match && match[7]?.length === 11) ? match[7] : false;
  }

  export const commaSeparatedString =(dataArray: any) => dataArray?.map((item:any) => item.value?.trim() ? item.value : "").join(', ');

  export function truncateText(text: string, limit = 10) {
    if (text?.length <= limit) {
      return text;
    }
  
    // Find the last space within the limit
    const truncated = text?.substring(0, limit);
    const lastSpaceIndex = truncated?.lastIndexOf(' ');
  
    // If a space is found, truncate at the last space, else truncate at the limit
    return lastSpaceIndex > 0 ? text?.substring(0, lastSpaceIndex) + '...' : text?.substring(0, limit) + '...';
  }


export function getExistingBusinessCode(data: any) {
  const result: any = [];
  data?.forEach((invite: any) => {
    if (invite?.referredTo?.length > 0) {
      invite?.referredTo.forEach((referredTo: any) => {
        if (referredTo.businessCode) {
          result.push(referredTo.businessCode);
        }
      });
    }
  });
  return result;
}

export function isValidEmail(email: string) {
  // Regular expression for validating an Email
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  return emailRegex.test(email);
}

export function appendRegisterReferrer(url:string) {
  // Create a new URL object
  const parsedUrl = new URL(url);

  // Split the pathname into segments
  const segments = parsedUrl.pathname.split('/');

  // Find the index of 'business-details'
  const index = segments.indexOf('business-details');

  // If 'business-details' is found, insert '/register-referrer' after it
  if (index !== -1) {
      segments.splice(index + 1, 0, 'register-referrer');
  }

  // Reconstruct the pathname
  parsedUrl.pathname = segments.join('/');

  // Return the modified URL as a string
  return parsedUrl.toString();
}

export function calculateCommission(finalAmount:number, percentage:number) {
  // Convert percentage to a decimal by dividing by 100
  const percentageDecimal = percentage / 100;

  // Calculate the commission by multiplying the final amount by the percentage decimal
  const commission = percentageDecimal && finalAmount * percentageDecimal;

  return commission;
}

export const getRoleBasedReward = (rewardList: any[], userData: any): any[] => {

  if (!rewardList || !userData) {
    return [];
  }

  const userRole = userData?.roleId;
  // Filter rewards based on userRole (adjust the logic as needed)
  const filteredRewards = userRole === 2 ? rewardList.filter((reward) => {
    // Example: Filter rewards for users with roleId 2
    return (reward.referralRewardValue !== '' || reward.referralRewardType !== '');
  }) : rewardList;

  return filteredRewards;
};

export const getRewardType = (value: any, type: any) => {
  return type === 'percentage' ?
    `% Commission (${value}%)` :
    type === 'cash' ?
      `Cash Reward ($${value})` :
      type === 'no-reward' ?
        `No Reward` :
        type === 'coupon' ?
          `Voucher or Freebie` :
          type === 'Voucher or Freebie' ?
          `Voucher or Freebie` : ""
} 

export const isAdminEmail=(email:string)=> {
  let emails = ['phil@referusnetwork.com', 'justin@referusnetwork.com']
  if(emails?.includes(email)) return true
  return false
}

let key:any = 9876543210
// Function to encrypt a number
export function encryptNumber(number:any, nKey = key) {
  return number ^ nKey;  // XOR the number with the key
}


interface BusinessRecord {
  business_name: string;
  first_name: string;
  last_name: string;
  email: string;
  mobile: string;
}

interface SeparatedRecords {
  validRecords: BusinessRecord[];
  invalidRecords: BusinessRecord[];
}
// ****** septate valid and invalid referrer list ************ //
export function separateRecords(records: BusinessRecord[]): SeparatedRecords {
  const validRecords: BusinessRecord[] = [];
  const invalidRecords: BusinessRecord[] = [];
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  records.forEach(record => {
      const { first_name, last_name, email, mobile, Email, Mobile, firstName, firstname, lastName, FirstName, LastName, lastname, Firstname, Lastname }: any = record;
      let recordObj: any = {
        firstName: first_name || firstName || Firstname || FirstName || firstname,
        lastName: last_name || lastName || Lastname || LastName || lastname,
        email: email || Email,
        mobile: mobile || Mobile
      };

      // Check if all required fields are filled and email is valid
      const isEmailValid = emailRegex.test(recordObj?.email);

      // Check if all key fields are empty
      const isAllFieldsEmpty = !recordObj.firstName && !recordObj.lastName && !recordObj.email && !recordObj.mobile;

      if (isAllFieldsEmpty) {
          // Do not push to either list if all fields are empty
          return;
      }

      if (recordObj?.firstName && recordObj?.lastName && recordObj?.email && recordObj?.mobile && isEmailValid) {
          validRecords.push(recordObj); // Add to valid records
      } else {
          invalidRecords.push(recordObj); // Add to invalid records
      }
  });

  return { validRecords, invalidRecords };
}


//  ***** convert to valid data for referrer card ***********

interface User {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  mobileNumber?: string; // This is required
  referralsCount: number;
  BusinessDetails: {
      id: number | null;
      logo: string | null;
      businessName: string;
      url: string | null;
      category: string | null;
      services: string | null;
  };
  referrals: Array<{ id: number; email: string; createdAt: string }>;
}

interface Invite {
  admin_id: number | null;
  firstName: string;
  lastName: string;
  email: string;
  mobileNumber: string; // This is required
  isRegistered: boolean;
  outstanding: number;
  totalIncome: number;
  referralsAmount: number;
  isRead: boolean;
  emailReminderSent: boolean;
  referrerBusinessDetails?: object;
  referrerId: number | null;
  user: User;
}

interface ReferrerReward {
  id: number;
  offerName: string;
  offerValue: number;
  offerType: string;
}

interface OutputFormat {
  id: number;
  invite_id: number | null;
  adminId?: number;
  senderCode: string;
  businessCategory: string | null;
  businessCode: string;
  businessName?: string;
  referralsCount: number;
  outstanding: number;
  totalIncome: number;
  referralsAmount: number;
  failedReferrals: number;
  isDefault: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  invite: Invite;
  referrerRewards: ReferrerReward[];
}

export function convertToBusinessFormat(input: any): OutputFormat {
  return {
      id: input.id,
      invite_id: null, // Assuming this is not available in the input
      senderCode: input.referrerCode,
      businessCategory: input?.BusinessDetails?.businessCategory || null,
      businessName: input?.BusinessDetails?.businessName || "",
      businessCode: input.businessCode,
      referralsCount: input.referralsCount,
      adminId: input?.id, 
      outstanding: input?.outstanding || 0, // Assuming default value
      totalIncome: 0, // Assuming default value
      referralsAmount: 0, // Assuming default value
      failedReferrals: 0, // Assuming default value
      isDefault: 0, // Assuming default value
      isActive: input.isActive,
      createdAt: input.createdAt,
      updatedAt: input.updatedAt,
      invite: {
          admin_id: null, // Assuming this is not available in the input
          firstName: input.firstName || input?.contactName,
          lastName: input.lastName,
          email: input.email,
          mobileNumber: input.mobileNumber,
          isRegistered: false, // Assuming default value
          outstanding: 0, // Assuming default value
          totalIncome: 0, // Assuming default value
          referralsAmount: 0, // Assuming default value
          isRead: input.isRead,
          emailReminderSent: false, // Assuming default value
          referrerBusinessDetails: {
            id: null, // Assuming this is not available in the input
            logo: null, // Assuming this is not available in the input
            businessName: input?.BusinessDetails?.businessName || "", // Default value if null
            url: null, // Assuming this is not available in the input
            category: input?.BusinessDetails?.businessCategory || null, // Default value if null
            services: input?.BusinessDetails?.services || null // Assuming this is not available in the input
          }, // Assuming default value
          referrerId: null, // Assuming this is not available in the input
          user: {
              id: input.id,
              firstName: input.firstName,
              lastName: input.lastName,
              email: input.email,
              referralsCount: input.referralsCount,
              BusinessDetails: {
                  id: null, // Assuming this is not available in the input
                  logo: null, // Assuming this is not available in the input
                  businessName: input?.BusinessDetails?.businessName || "", // Default value if null
                  url: null, // Assuming this is not available in the input
                  category: input?.BusinessDetails?.businessCategory || null, // Default value if null
                  services: null // Assuming this is not available in the input
              },
              referrals: [] // Assuming no referrals in the input
          }
      },
      referrerRewards: [] // Assuming no rewards in the input
  };
}

export function convertToReferralBusinessFormat(input: any): any {
  return {
      id: input.id,
      invite_id: null, // Assuming this is not available in the input
      sender_id: input.adminId,
      firstName: input.contactName || "", // Assuming contactName is used for firstName
      lastName: "", // Assuming lastName is not available in the input
      email: input.email,
      mobileNumber: input.mobileNumber || "", // Default to empty string if not provided
      businessCode: input.admin.businessCode || "", // Assuming this is from the admin
      outcome: input.outcome ? "success" : "pending", // Adjust based on your logic
      paidOffer: 0, // Assuming default value
      totalAmountPaid: 0, // Assuming default value
      contactedDate: null, // Assuming this is not available in the input
      isRead: input.isRead,
      adminId: input?.adminId,
      isEmailSent: false, // Assuming default value
      createdAt: input.createdAt,
      businessName: input.companyName || "", // Default value if null
      selfSend: 0, // Assuming default value
      sender: {
          firstName: input.admin.contactName || "", // Assuming this is the sender's first name
          lastName: "", // Assuming lastName is not available in the input
          email: input.admin.email,
          contactName: input.admin.contactName || null,
          BusinessDetails: {
              businessName: input.companyName || "", // Default value if null
              url: null, // Assuming this is not available in the input
              category: null, // Assuming this is not available in the input
              services: null, // Assuming this is not available in the input
              description: null, // Assuming this is not available in the input
              contactPerson: input.admin.contactName || null, // Assuming this is the contact person
              contactNumber: input.admin.businessCode || null // Assuming this is not available in the input
          }
      },
      rewards: [], // Assuming no rewards in the input
      referralsCount: input.admin.referralsCount || 0, // Assuming this is from the admin
      businessCategory: null, // Assuming this is not available in the input
      senderCode: input.admin.referrerCode || "", // Assuming this is from the admin
  };
}

// ************ making super admin outstanding data to business data label *************** //
import { Rule } from 'antd/es/form';

export const convertOldTableDataToNew = (listData: any) => {
  let updatedList = listData?.map((originalObject: any) => {
    return {
      id: originalObject?.id,
      sender_id: originalObject?.adminId, // Corresponding admin ID
      firstName: originalObject?.contactName.split(" ")[0] || "", // Extract first name
      lastName: originalObject?.contactName.split(" ")[1] || "",  // Extract last name
      email: originalObject?.email,
      mobileNumber: originalObject?.mobileNumber || "", // Use mobileNumber or default to empty
      businessCode: originalObject?.admin.BusinessDetails.businessCode || "", // Business code
      businessName: originalObject?.admin.BusinessDetails.businessName || null, // Business name
      outcome: originalObject?.outcome ? "success" : "pending", // Convert outcome to string
      paidOffer: originalObject?.paidOffer ? originalObject?.paidOffer : 'Yes', // Example transformation for paidOffer
      totalAmountPaid: originalObject?.paidOffer ? originalObject?.paidOffer : 'Yes', // Example transformation for total amount paid
      contactedDate: originalObject?.updatedAt, // Assuming contactedDate corresponds to updatedAt
      isReferUs: false, // Defaulting to false
      isEmailSent: true, // Defaulting to true
      isReferrerPaid: false, // Defaulting to false
      isRead: originalObject?.isRead || false, // Use isRead or default to false
      createdAt: originalObject?.createdAt,
      updatedAt: originalObject?.updatedAt,
    }
  })
  return updatedList
}

export const platformNameRules: Rule[] = [
    { required: true, message: 'Please input the platform name!' },
    { min: 3, message: 'Platform name must be at least 3 characters long!' },
    { max: 50, message: 'Platform name cannot be longer than 50 characters!' },
    {
        pattern: /^[a-zA-Z0-9\s-]+$/,
        message: 'Platform name can only contain alphanumeric characters, spaces, and hyphens!',
    },
];

export const platformUrlRules: Rule[] = [
    { required: true, message: 'Please input the platform URL!' },
    { type: 'url', message: 'Please enter a valid URL!' },
];

export const redirectUrlsRules: Rule[] = [
    { required: true, message: 'Please input the redirect URLs!' },
    {
        validator: (_: any, value: string) => {
            if (!value) {
                return Promise.resolve();
            }
            const urls = value.split(',').map((url: string) => url.trim()).filter(Boolean);
            const invalidUrls = urls.filter((url: string) => {
                try {
                    new URL(url);
                    return false;
                } catch (_) {
                    return true;
                }
            });
            if (invalidUrls.length > 0) {
                return Promise.reject(new Error(`Invalid URL(s): ${invalidUrls.join(', ')}`));
            }
            return Promise.resolve();
        },
    },
];

export const contactEmailRules: Rule[] = [
    { required: true, message: 'Please input a valid contact email!' },
    { type: 'email', message: 'Please input a valid contact email!' }
];

export const contactPersonRules: Rule[] = [
    { required: true, message: 'Please input the contact person!' },
    { min: 3, message: 'Contact person name must be at least 3 characters long!' },
    { max: 50, message: 'Contact person name cannot be longer than 50 characters!' },
    {
        pattern: /^[a-zA-Z\s]+$/,
        message: 'Contact person name can only contain letters and spaces!',
    },
];